import type { TFunction } from 'i18next'

import { map, pipe, prop, uniq } from 'lodash/fp'

import { getAnchorsTypesChoices } from '@/entities/anchor'

export const generateSourceFamilyId = () =>
	String(Math.floor(Math.random() * 1000000))

export const getAnchorTypesOptionsList = (t: TFunction) =>
	getAnchorsTypesChoices(t).map((item) => ({
		...item,
		description: t(`app.${item.value}_anchor.description`),
	}))

export const hasSingleSalesEntity = pipe(
	map(prop('sales_entity_id')),
	uniq,
	(ids) => ids.length === 1
)
